import React from 'react';
import { Bug, ChevronDown, ChevronRight, History, PanelLeftClose, X } from 'lucide-react';
import BrandMark from '../BrandMark';
import SidebarUtilityButton from '../SidebarUtilityButton';

/** Private presentation. Account status, navigation and modal actions remain supplied by OfficeSidebar. */
export function PremiumSidebarIdentity({ name, logoUrl, displayName, roleLabel, onClose, onCollapse, mobileSheet = false, children }) {
  const initials = String(displayName || name).trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  return <div className="premium-sidebar-identity">
    <div className="premium-sidebar-brand-row">
      <div className="premium-sidebar-brand-copy">
        <BrandMark name={name} logoUrl={logoUrl} variant="square" size={30} logoMaxWidth={124} showName className="office-sidebar-brand" />
        {mobileSheet && <h2 className="office-mobile-menu-title">Mais opções</h2>}
        
      </div>
      {onCollapse ? <button type="button" className="office-sidebar-collapse" aria-label="Recolher menu" aria-expanded="true" aria-controls="office-main-sidebar" title="Recolher menu" onClick={onCollapse}><PanelLeftClose size={18} aria-hidden="true" /></button>
        : <button type="button" className="office-sidebar-close" aria-label="Fechar menu" onClick={onClose}><X size={18} aria-hidden="true" /></button>}
    </div>
    <details className="premium-sidebar-account">
      <summary>
        <span className="premium-sidebar-avatar" aria-hidden="true">{initials}</span>
        <span className="premium-sidebar-account-copy"><strong>{displayName}</strong><small>{roleLabel}</small></span>
        <ChevronDown size={16} className="premium-sidebar-account-chevron" aria-hidden="true" />
      </summary>
      <div className="premium-sidebar-account-details">{children}</div>
    </details>
  </div>;
}

export function PremiumSidebarFooter({ officeName, buildLabel, t, support, onHistory, onReport }) {
  return <div className="premium-sidebar-footer" data-testid="sidebar-office-meta">
    {support}
    <div className="premium-sidebar-utility-actions">
      <button type="button" onClick={onHistory} data-testid="sidebar-release-history" title={t('sidebar.releaseHistory')}><History size={16} aria-hidden="true" /><span>{t('sidebar.releaseHistory')}</span><ChevronRight size={14} className="premium-sidebar-utility-arrow" aria-hidden="true" /></button>
      <SidebarUtilityButton icon={Bug} onClick={onReport} data-testid="sidebar-report-bug">{t('sidebar.reportBug')}</SidebarUtilityButton>
    </div>
    <p title={t('sidebar.poweredBy') + ' Dragon Tech'}><strong>{officeName}</strong>{buildLabel && <span>{buildLabel}</span>}</p>
  </div>;
}
